import { actionTypes } from "../utils";

export const types = {
  ...actionTypes('SET_DOCUMENTS'),
  ...actionTypes('SET_INTERNAL_OBLIGATIONS'), 
  ...actionTypes('CREATE_INTERNAL_OBLIGATION'),
  ...actionTypes('UPDATE_INTERNAL_OBLIGATION'),
  ...actionTypes('RESET_INTERNAL_OBLIGATIONS'),
  ...actionTypes('ASSIGN_INTERNAL_USER'),
  ...actionTypes('MASS_ASSIGN_INTERNAL_OBLIGATIONS'),
  ...actionTypes('DELETE_INTERNAL_OBLIGATION'),
};